// What a response read from TRACON's own tables (Supabase) says it does NOT
// carry yet (Phase B after, lane A; review A-R5).
//
// When a v3.read_store.* flag reads 'supabase', the API answers with the same
// body shape as the Zoho path and two headers: X-TRACON-Read-Store and
// X-TRACON-Not-Carried (the fields that store has no home for yet, which it
// answers blank). A label nobody renders is a label that was not issued, so
// api.js hands every such header pair here and <ReadStoreNotice /> shows it.
// With every flag on 'zoho' (the default) no response carries the headers and
// nothing renders.

const EVENT = 'tracon:read-store';
const notices = new Map(); // path (no query) -> { path, store, notCarried: string[], status, at }

/** The not-carried header split into its items; 'none' and blanks are no items. */
export function parseNotCarried(header) {
  return String(header || '')
    .split(';')
    .map((s) => s.trim())
    .filter((s) => s && s !== 'none');
}

/** Called by api.js for a response that carries X-TRACON-Read-Store. */
export function recordReadStore(path, store, notCarriedHeader, status) {
  if (!store || store === 'zoho') return;
  const key = String(path || '').split('?')[0];
  notices.set(key, { path: key, store, notCarried: parseNotCarried(notCarriedHeader), status: status || 200, at: Date.now() });
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENT));
}

/** Every notice recorded since the last clear, newest first. */
export function readStoreNotices() {
  return [...notices.values()].sort((a, b) => b.at - a.at);
}

/** Drop every notice (a route change: the next page records its own). */
export function clearReadStoreNotices() {
  if (!notices.size) return;
  notices.clear();
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENT));
}

export const READ_STORE_EVENT = EVENT;
